import { render, staticRenderFns } from "./vectorTaskCount.vue?vue&type=template&id=32774cb7&scoped=true&"
import script from "./vectorTaskCount.vue?vue&type=script&lang=js&"
export * from "./vectorTaskCount.vue?vue&type=script&lang=js&"
import style0 from "./vectorTaskCount.vue?vue&type=style&index=0&id=32774cb7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32774cb7",
  null
  
)

export default component.exports